import React, { useState, useEffect } from "react";
import axiosClient from "../../../utils/axiosClient";
import { urlServicosAgendamentoEmpresas } from "../../../utils/constants";
import {
  IonLabel,
  IonContent,
  IonBadge,
  IonButton,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonItem,
  IonList,
} from "@ionic/react";

export default function ModalServicos({
  modalServicos,
  setModalServicos,
  onServicoSelecionado,
}) {
  const [servicos, setServicos] = useState([]);

  useEffect(() => {
    const consultaServicos = async () => {
      try {
        const response = await axiosClient.post(
          urlServicosAgendamentoEmpresas,
          {}
        );
        setServicos(response.data);
      } catch (error) {
        setServicos([]);
      }
    };

    if (modalServicos) {
      consultaServicos();
    }
  }, [modalServicos]);

  const handleSelecionarServico = (servico) => {
    onServicoSelecionado(servico);
    setModalServicos(false);
  };

  const retornarTempo = (minutos) => {
    if (minutos < 60) {
      return `${minutos} minutos`;
    }
    const horas = Math.floor(minutos / 60);
    const minutosRestantes = minutos % 60;

    if (horas === 1) {
      return minutosRestantes === 0
        ? "1 hora"
        : `1 hora e ${minutosRestantes} minutos`;
    }
    if (minutosRestantes === 0) {
      return `${horas} horas`;
    }
    return `${horas} horas e ${minutosRestantes} minutos`;
  };

  return (
    modalServicos && (
      <IonModal isOpen={true} mode="ios" backdropDismiss={false}>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => setModalServicos(false)}>
                Fechar
              </IonButton>
            </IonButtons>
            <IonTitle>Escolha um serviço</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonList>
            {servicos.map((servico, index) => (
              <IonItem key={index} button onClick={() => handleSelecionarServico(servico)}>
                <IonLabel>
                  <h4>{servico.nome}</h4>
                  <IonBadge color="secondary-light">
                    Tempo estimado: {retornarTempo(servico.tempo)}
                  </IonBadge>
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        </IonContent>
      </IonModal>
    )
  );
  
}
